import {hostName} from "../endpoint";
import {defaultHeaders} from "../headers";

export const checkBusinessName = async (name) => {
  const result = await fetch(`${hostName}/business/is-valid`, {
    method: "POST",
    headers: defaultHeaders,
    body: JSON.stringify(name),
  });
  return result.json();
};
